function initLink() {
    const $body = document.body;
    const $links = document.querySelectorAll('a');
    if ($links.length && !$body.classList.contains('user-logged-in')) {
        function init() {
            const $body = document.querySelector('body');
            const $modal = document.querySelector('.modal-coop');
            const $btnAccept = $modal.querySelector('.accept');
            const $btnNoAccept = $modal.querySelector('.no-accept');
            $links.forEach($link => {
                const $linkHref = ($link.getAttribute('href') || '').trim();
                if ($linkHref && $linkHref.charAt(0) !== '/' && $linkHref.charAt(0) !== '#' && !$linkHref.includes(location.host)) {
                    $link.addEventListener('click', (event) => {
                        event.preventDefault();
                        $modal.classList.remove('d-none');
                        $body.classList.add('scrollLock');
                        $btnAccept.removeEventListener('click', () => { });
                        $btnAccept.addEventListener('click', () => {
                            window.open(($link.getAttribute('href') || '').trim(), 'New Window');
                            closeModal($modal, $body);
                        });
                        $btnNoAccept.removeEventListener('click', () => { });
                        $btnNoAccept.addEventListener('click', () => {
                            closeModal($modal, $body);
                        });
                    });
                    document.body.addEventListener('click', (event) => {
                        if (event.target == $modal) {
                            closeModal($modal, $body);
                        }
                    });
                }
            });
        }
        function closeModal($modal, $body) {
            $modal.classList.add('d-none');
            $body.classList.remove('scrollLock');
        }
    }
}
